import { buildVenuePath } from '../utils/venueRouting';
import React, { useState, useEffect, useContext } from 'react';
import AppContext from '../contexts/AppContext';
import { Link, useLocation } from 'react-router-dom';
import { openDiscover } from '../utils/discover';
import { useNavigate } from 'react-router-dom';
const STATIC_TABS = [
  { name: 'Home', path: '/' },
  { name: 'Services', path: '/service' },
  { name: 'Map', path: '/map' },
  { name: 'Discover', path: '/discover' },
];

const BottomTabs = () => {
  const { hotelInfo, theme, venueId } = useContext(AppContext);
  const navigate = useNavigate();
  const location = useLocation();

  const [displayTabs, setDisplayTabs] = useState(STATIC_TABS);

  useEffect(() => {
    if (!hotelInfo) return;
    setDisplayTabs(
      hotelInfo.area_id === 'area_00'
        ? STATIC_TABS.filter(tab => tab.name !== 'Discover')
        : STATIC_TABS
    );
  }, [hotelInfo]);

  const bottomText = (theme?.color || theme?.secondaryColor) ? 'rgb(156 163 175)' : theme?.bottomText;
  const bottomTextSelected = (theme?.color || theme?.secondaryColor) ? 'rgb(0,0,0)' : theme?.bottomTextSelected;
  const bottomBackground = (theme?.color || theme?.secondaryColor) ? 'rgb(243,244,246)' : theme?.bottomBackground;


  const handleDiscoverClick = () => {
    const activities = hotelInfo?.area?.activity || [];
    const hasActivity = activities.length > 0;
    const bitlyUrl = hotelInfo?.area?.bitlyUrl;

    if (hasActivity) {
      navigate(buildVenuePath('/discover-special', venueId));
    } else {
      openDiscover(bitlyUrl);
    }
  };


  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 h-16"
      style={{
        boxShadow: '0 -0.3rem 0.5rem rgba(0, 0, 0, 0.1)',
        backgroundColor: bottomBackground,
      }}
    >
      <ul className="flex justify-around h-full">
        {displayTabs.map(tab => {
          // const selected = location.pathname === tab.path; 因为现在暂时有个discover-special的路径
          const selected =
            tab.name === 'Discover'
              ? location.pathname.startsWith('/discover') // 包括 /discover-special
              : location.pathname === tab.path;
          return (
            <li key={tab.name} className="flex-1 text-center p-2"
              style={{
                color: selected ? bottomTextSelected : bottomText,
              }}>
              {tab.name === 'Discover' ? (
                <button onClick={handleDiscoverClick} className="flex items-center justify-center h-full w-full">
                  <span className="font-semibold pb-1"
                    style={{
                      borderBottom: selected ? `2px solid ${bottomTextSelected}` : 'none',
                    }}>
                    {tab.name}
                  </span>
                </button>
              ) : (
                <Link to={buildVenuePath(tab.path, venueId)} className="flex items-center justify-center h-full">
                  <span className="font-semibold pb-1"
                    style={{
                      borderBottom: selected ? `2px solid ${bottomTextSelected}` : 'none',
                    }}>
                    {tab.name}
                  </span>
                </Link>
              )}
            </li>
          )
        })}
      </ul>
    </nav>
  );
};

export default BottomTabs;
